const __request = require(`@/lib/data-service/default/__request/__request_contentType_json`);
/**
 * 个人信息设置
 */
export default function (val) {
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/web/personage/personageSet"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}
